<div>
  @if (selectedApplyOpt == "EXPENSES") {
    <div class="card">
      <div class="card-body">
        <table class="table table-borderless">
          <tr>
            <th>Cash In Office:</th>
            <th>RM {{ cashInOffice | number: "1.2-2" }}</th>
          </tr>
          <tr>
            <th>Last Verified Date:</th>
            <th>{{ lastCheckedInDate | date: "dd-MM-yyyy" }}</th>
          </tr>
        </table>
      </div>
    </div>
  }

  <form method="post" class="d-flex flex-column gap-3 mt-2">
    @if (selectedApplyOpt != "TICKET") {
      <mat-slide-toggle
        class="mat-slide-toggle-lg"
        [hideIcon]="true"
        color="primary"
        [(ngModel)]="isShared"
        (ngModelChange)="addLoggedInCompanyIntoList()"
        name="isShared"
      >
        Share Apply</mat-slide-toggle
      >
    }

    <div class="form-floating">
      <input
        type="number"
        class="form-control"
        id="totalAmount"
        name="totalAmount"
        placeholder="Applied Amount"
        [(ngModel)]="totalAmount"
        required
      />
      <label for="totalAmount">Applied Amount</label>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-floating">
          <textarea
            type="text"
            class="form-control"
            id="reason"
            name="reason"
            placeholder="Reason/Remark"
            [(ngModel)]="reason"
            required
          ></textarea>
          <label for="reason">Reason/Remark</label>
        </div>
      </div>
      @if (selectedApplyOpt == "KERJA") {
        <div class="col-3">
          <button
            type="button"
            class="btn btn-info"
            (click)="searchCustomerAndLoadDetails()"
          >
            Load Customer Details
          </button>
        </div>
      }
    </div>

    <!--Make sure total amount was filled in-->
    @if (totalAmount > 0) {
      @if (selectedApplyOpt == "TICKET") {
        <h3 class="mt-2">
          Ticket Details
          @if (totalTicketAmount > 0) {
            (RM {{ totalTicketAmount | number: "1.2-2" }})
          }
          @if (loanRequestList.length == 0) {
            <button
              type="button"
              class="btn btn-info"
              (click)="selectTicket(false)"
            >
              Select Ticket
            </button>
          } @else {
            <button
              type="button"
              class="btn btn-info"
              (click)="selectTicket(true)"
            >
              Select Approved With Loan
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="clearTickets()"
            >
              <i class="fas fa-times"></i>
            </button>
          }
        </h3>
      }

      @if (groupedLoanRequestList.length > 0) {
        @for (group of groupedLoanRequestList; track group; let i = $index) {
          <div class="card">
            <div class="card-body">
              <p>
                {{ group.ids }} - {{ group.customerInfo }} -
                <b>RM {{ group.totalOnHand | number: "1.2-2" }} </b>| Form J:
                {{ group.formJCompany }}
              </p>
            </div>
          </div>
        }
        <hr />
      }

      @if (bankInDetailsList.length > 0) {
        <h3>Bank In Account Details</h3>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>Account Details</th>
              <th>Bank in Amount (RM)</th>
            </tr>

            @for (bank of bankInDetailsList; track bank; let i = $index) {
              <tr>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger me-3"
                    (click)="removeBank(i)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                  <strong>{{ bank.bankInAccount.HolderName }}</strong>
                  <span> ({{ bank.bankInAccount.Bank }} </span>
                  <span>{{ bank.bankInAccount.AccountNumber }})</span>
                </td>
                <td>
                  <div class="form-floating">
                    <input
                      type="number"
                      class="form-control"
                      id="amount"
                      name="amount"
                      placeholder="Amount"
                      [(ngModel)]="bank.amount"
                      required
                      (ngModelChange)="onAmountChange()"
                    />
                    <label for="reason">Amount</label>
                  </div>
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">
                Total :RM {{ totalBankAmount | number: "1.2-2" }} |
                <span
                  [ngClass]="{ 'text-danger': totalBankAmount != totalAmount }"
                  >Remaining :RM
                  {{ totalAmount - totalBankAmount | number: "1.2-2" }}</span
                >
              </th>
            </tr>
          </tfoot>
        </table>
      }

      @if (this.sharedService.roundTo2Dec(totalAmount) != this.sharedService.roundTo2Dec(totalBankAmount)) {
        @if (selectedCustomer != undefined) {
          <button
            type="button"
            class="btn btn-primary"
            (click)="openSelectCustomerAccounts()"
          >
            Select Customer Account
          </button>
        } @else if (selectedApplyOpt != "TICKET") {
          <button
            type="button"
            class="btn btn-primary"
            (click)="openAddBankInAccountModal()"
          >
            Add Bank In Account
          </button>
        }
      }

      @if (appliedBranchList.length > 0) {
        <h3>
          Shared Details
          @if (appliedBranchList.length > 1) {
            <span>
              @if (selectedApplyOpt != "TICKET") {
                <button class="btn btn-primary" (click)="sharedEvenly()">
                  Share evenly
                </button>
              }
            </span>
          }

          @if (selectedApplyOpt == "TICKET") {
            <mat-slide-toggle
              class="mat-slide-toggle-lg"
              [hideIcon]="true"
              color="primary"
              [(ngModel)]="includeKerja"
              name="includeKerja"
            >
              Overlap KERJA?</mat-slide-toggle
            >
          }
        </h3>

        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>Branches</th>
              <th>Shared Amount (RM)</th>
              @if (includeKerja) {
                <th>KERJA Amount (RM)</th>
              }
            </tr>

            @for (branch of appliedBranchList; track branch; let i = $index) {
              <tr>
                <td>
                  @if (selectedApplyOpt != "TICKET") {
                    @if (branch.appliedBranch.ID != companyId) {
                      <button
                        type="button"
                        class="btn btn-danger me-2"
                        (click)="removeBranch(i)"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    }
                  }
                  <span>{{ branch.appliedBranch.CompanyCode }}</span>
                </td>
                <td>
                  <div class="form-floating">
                    <input
                      type="number"
                      class="form-control"
                      [id]="'branchAmount-' + i"
                      [name]="'branchAmount-' + i"
                      placeholder="Amount"
                      [(ngModel)]="branch.amount"
                      required
                      (ngModelChange)="onAmountChange()"
                      [disabled]="selectedApplyOpt == 'TICKET'"
                    />
                    <label [for]="'branchAmount-' + i">Amount</label>
                  </div>
                </td>

                @if (includeKerja) {
                  <td>
                    <div class="form-floating">
                      <input
                        type="number"
                        class="form-control"
                        [id]="'kerja-' + i"
                        [name]="'kerja-' + i"
                        placeholder="Kerja Amount"
                        [(ngModel)]="branch.kerja"
                        required
                        (ngModelChange)="onAmountChange()"
                      />
                      <label [for]="'kerja-' + i">Amount</label>
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">
                Total :RM {{ totalBranchAmount | number: "1.2-2" }} |
                <span
                  [ngClass]="{
                    'text-danger': totalBranchAmount != totalAmount,
                  }"
                  >Remaining :RM
                  {{ totalAmount - totalBranchAmount | number: "1.2-2" }}</span
                >
              </th>
            </tr>
          </tfoot>
        </table>
      }

      @if (
        isShared &&
        totalAmount - totalBranchAmount != 0 &&
        totalAmount - totalBankAmount == 0
      ) {
        <app-search-company-by-uid
          (passEntry)="getSelectedCompany($event)"
        ></app-search-company-by-uid>
      }
    }
    <div class="d-flex justify-content-end">
      <hr />
      <button
        class="btn btn-outline-success"
        type="button"
        (click)="submit()"
        [disabled]="disabledSubmit"
      >
        Submit
      </button>
    </div>
  </form>
</div>
